import React from 'react';
import { useLocation } from 'react-router-dom';
import cx from 'classnames';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    makeStyles,
    Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiRouterLink from '€components/MuiRouterLink';
import { Routes } from '€lib/routing';

const useStyles = makeStyles(theme => ({
    accordion: {
        boxShadow: 'none',
        '& .MuiAccordionSummary-content': {
            marginTop: 0,
            marginBottom: 0,
        },
        '&.Mui-expanded:first-child': {
            marginTop: '-2rem',
        },
        '&.MuiAccordion-root:before': {
            backgroundColor: 'transparent',
        },
        '& .MuiAccordionSummary-root': {
            padding: 0,
        },
        '&.MuiAccordion-root.Mui-expanded': {
            margin: 0,
        },
        '& .MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '48px',
        },
        border: 'none',
    },
    active: {
        '&.MuiAccordionSummary-root': {
            borderLeft: `3px solid ${theme.palette.primary.main}`,
            color: `${theme.palette.primary.main}`,
            paddingLeft: '1.9rem',
            marginLeft: '-2.2rem',
        },
        '&.MuiLink-root': {
            color: `${theme.palette.primary.main}`,
        },
    },
    inActive: {
        '&.MuiAccordionSummary-root': {
            borderLeft: `3px solid transparent`,
            color: `${theme.palette.text.primary}`,
            '&:hover': {
                color: `${theme.palette.primary.main}`,
            },
        },
        '&.MuiLink-root': {
            color: `${theme.palette.text.primary}`,
        },
    },
}));

const AboutUsAccordian: React.FunctionComponent = () => {
    const { pathname } = useLocation();
    const classes = useStyles();
    return (
        <>
            <Accordion className={classes.accordion}>
                <AccordionSummary
                    className={cx({
                        [classes.active]:
                            pathname === Routes.UserPrivacyPolicy ||
                            pathname === Routes.UserTermsOfUse,
                        [classes.inActive]:
                            pathname !== Routes.UserPrivacyPolicy &&
                            pathname !== Routes.UserTermsOfUse,
                    })}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="subtitle1">About us</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box display="flex" flexDirection="column">
                        <MuiRouterLink
                            className={cx({
                                [classes.active]: pathname === Routes.UserPrivacyPolicy,
                                [classes.inActive]: pathname !== Routes.UserPrivacyPolicy,
                            })}
                            to={{
                                pathname: `${Routes.UserPrivacyPolicy}`,
                                state: {
                                    path: `${Routes.Dashboard}`,
                                },
                            }}
                            underline="none"
                        >
                            <Box py={1.5} display="flex" justifyContent="space-between">
                                <Typography variant="subtitle2">Privacy Policy</Typography>
                            </Box>
                        </MuiRouterLink>
                        <MuiRouterLink
                            className={cx({
                                [classes.active]: pathname === Routes.UserTermsOfUse,
                                [classes.inActive]: pathname !== Routes.UserTermsOfUse,
                            })}
                            to={{
                                pathname: `${Routes.UserTermsOfUse}`,
                                state: {
                                    path: `${Routes.Dashboard}`,
                                },
                            }}
                            underline="none"
                        >
                            <Box py={1.5} display="flex" justifyContent="space-between">
                                <Typography variant="subtitle2">Terms of Use</Typography>
                            </Box>
                        </MuiRouterLink>
                    </Box>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default AboutUsAccordian;
